import axios from "../api/axiosInstance";

export const GetAllProductPrice = async () => {
    return await axios.get("/ProductPrice/GetAll");
};

export const GetProductPriceById = async (id) => {
    return await axios.get(`/ProductPrice/GetById/${id}`);
};

export const GetProductPriceByProductId = async (productId) => {
    return await axios.get(`/ProductPrice/GetByProductId/${productId}`);
};

export const AddProductPrice = async (model) => {
    return await axios.post("/ProductPrice/Add", model);
};

export const UpdateProductPrice = async (model) => {
    return await axios.put("/ProductPrice/Update", model);
};

export const RemoveProductPrice = async (id) => {
    return await axios.delete(`/ProductPrice/Delete/${id}`);
};
export const GetActiveProductPrices = async () => {
    return await axios.get("/ProductPrice/active");
};